export default () => {
  const config = {}
  for (let key in process.env) {
    const clearKey = key.replace(/^REACT_APP_/, '')
    config[clearKey] = process.env[key]
  }
  return config
}
